import nyNetwork from "@/api/nyBaseNetwork";
import DZModelPage from "@/model/DZModelPage";
import DZModelOpenCity from "@/views/系统设置/model/DZModelOpenCity";

class DZServiceCity{

    m_page = new DZModelPage(10)

    list_city :Array<DZModelCity> = []

    list_all_city :Array<DZModelCity> = []

    net_city_list(){
        nyNetwork.net("三级城市列表",{}, data => {
            this.list_city = data
        })
    }

    net_open_city(idList){
        nyNetwork.net("开通城市",idList, data => {})
    }

    net_operate_city(id,success: () => void){
        nyNetwork.net("冻结解冻城市",{id:id}, data => {
            success()
        })
    }

    net_del_city(id,success: () => void){
        nyNetwork.net("删除已开通城市",{id:id}, data => {
            success()
        })
    }

    net_edit_city(id,sld,success: () => void){
        nyNetwork.net("编辑二级域名",{id:id,sld:sld}, data => {
            success()
        })
    }

    net_edit_cityName(id,name,success: () => void){
        nyNetwork.net("编辑城市名称",{id:id,name:name}, data => {
            success()
        })
    }

    net_all_city(){
        nyNetwork.net("城市列表",{}, data => {
            this.list_all_city = data
        })
    }

    net_list_city(success: () => void){
        nyNetwork.net("开通城市列表",{}, data => {
            success()
        })
    }

    net_add_address(success: () => void){
        nyNetwork.net("添加详细地址",{}, data => {
            success()
        })
    }

    net_edit_address(success: () => void){
        nyNetwork.net("修改详细地址",{}, data => {
            success()
        })
    }

    net_get_address(success: () => void){
        nyNetwork.net("获得详细地址",{}, data => {
            success()
        })
    }
}

export default DZServiceCity;